<template>
  <div class="my-6 mb-10 pb-10">
    <!-- Event Card -->
    <v-card
      v-for="(event, i) in events"
      :key="i"
      @click="
        $root.routeTo({
          name: 'EventCard',
          params: { no: event.no },
        })
      "
      style="cursor: pointer"
      tile
      elevation="4"
      class="my-4"
    >
      <v-row no-gutters class="d-flex">
        <!-- Event Date -->
        <v-col cols="12" md="2">
          <v-card height="50%" tile color="secondary">
            <div class="text-center text-h5 py-3 white--text">
              {{ new Date(event.startDate).getDate() }}
              <sup class="text-uppercase">{{
                getOrdinalSuffix(new Date(event.startDate).getDate())
              }}</sup>
            </div>
          </v-card>
          <v-card height="50%" tile color="primary" class="text-center">
            <v-card-text>
              <span style="color: #fff" class="text-uppercase text-h5">{{
                months[new Date(event.startDate).getMonth()]
              }}</span>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Event Details -->
        <v-col cols="12" md="1">
          <div class="my-3">
            <badge v-if="event.cPDTerms" :cpd-caption="event.cPDTerms" />
            <CPDbadge v-else :cpd-points="event.cpdHours" />
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="px-3 my-3 event-details">
            <div class="dateText event-description">
              <p class="font-weight-medium">{{ event.description }}</p>

              <div class="event-dates">
                <span class="date-separator"> | </span>
                <span class="mr-2 text-body-1">
                  From
                  {{
                    getFormattedDate(
                      formatForISO(event.startDate, event.startTime)
                    )
                  }}
                </span>
                <span class="mr-2 text-body-1">
                  To
                  {{
                    getFormattedDate(formatForISO(event.endDate, event.endTime))
                  }}
                </span>
              </div>
            </div>
            <div class="d-lg-flex flex-row">
              <v-chip-group column>
                <v-chip color="secondary" class="white--text">
                  {{ event.eventType }}
                </v-chip>
                <v-chip color="secondary" class="white--text">
                  {{ event.location }}
                </v-chip>
                <v-chip
                  color="secondary"
                  v-for="(provider, index) in event.eventProviders"
                  :key="index"
                  class="white--text"
                >
                  {{ provider.name }}
                </v-chip>
              </v-chip-group>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="3" class="pa-3">
          <div class="d-flex flex-row justify-center justify-lg-end items-center my-3">
            <v-btn
              @click="
                $root.routeTo({
                  name: 'EventCard',
                  params: { no: event.no },
                })
              "
              color="primary"
            >
              <v-icon left>book_online</v-icon>
              {{ settings?.BookHere }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import eventMixin from "../eventMixin";
import CPDbadge from "./CPDbadge.vue";
import badge from "./badge.vue";
export default {
  name: "EventList",
  components: {
    CPDbadge,
    badge,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  mixins: [eventMixin],
  data() {
    return {
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  computed: {
    cpd_caption() {
      return process.env.VUE_APP_CPD_CAPTION;
    },
    settings() {
      return this.$store.getters["Admin/adminGetters"]("settings");
    },
  },
  methods: {
    formatForISO(date, time) {
      return `${date}T${time}`;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 320px) {
  .event-details {
    margin-left: 12px;
  }

  .event-description {
    font-size: 0.85rem;
    margin-left: 8px;
  }

  .event-description .font-weight-medium {
    font-size: 0.85rem;
    display: block;
    margin-bottom: 4px;
  }

  .date-separator {
    display: none;
  }

  .event-dates {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
  }

  .event-dates span {
    font-size: 0.85rem;
    line-height: 1.4;
  }
}
</style>
